<template>

    <section>

        <div class="md_common-bl _padding-add">
            <div class="inner" style="display: flex; justify-content: flex-start; gap: 1rem;">

                <!-- ここから -->

                <!-- Mail -->
                <a href="" class="btn_svg-icon _notice">
                    <SvgIconMail />
                </a>

                <!-- Chat -->
                <a href="" class="btn_svg-icon _notice">
                    <SvgIconChat />
                </a>

                <!-- ここまで -->

            </div><!--/.inner-->
        </div><!--/.md-common-bl-->

    </section>

</template>


<script>
    import { Link } from '@inertiajs/inertia-vue3'

    //Svg
    import SvgIconEdit from '@/components/EndUser/svg/SvgIconEdit'
    import SvgIconAdd from '@/components/EndUser/svg/SvgIconAdd'
    import SvgIconCheck from '@/components/EndUser/svg/SvgIconCheck'
    import SvgIconCancel from '@/components/EndUser/svg/SvgIconCancel'
    import SvgIconBack from '@/components/EndUser/svg/SvgIconBack'
    import SvgIconDelete from '@/components/EndUser/svg/SvgIconDelete'
    import SvgIconImagePlace from '@/components/EndUser/svg/SvgIconImagePlace'
    import SvgIconMail from '@/components/EndUser/svg/SvgIconMail'
    import SvgIconChat from '@/components/EndUser/svg/SvgIconChat'
    import SvgIconSearch from '@/components/EndUser/svg/SvgIconSearch'
    import SvgIconSend from '@/components/EndUser/svg/SvgIconSend'
    import SvgIconReload from '@/components/EndUser/svg/SvgIconReload'

    export default {
        components: {
            "Link": Link,
            //Svg
            SvgIconEdit,
            SvgIconCheck,
            SvgIconCancel,
            SvgIconBack,
            SvgIconBack,
            SvgIconDelete,
            SvgIconImagePlace,
            SvgIconMail,
            SvgIconChat,
            SvgIconSearch,
            SvgIconSend,
            SvgIconReload,
            SvgIconAdd
        },
    }
</script>
